import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { notify } from "react-notify-toast";
// import Spinner from "../../Components/Spinner"
import { PORT } from "../../config";
import { GoogleLogin } from "react-google-login";
import PasswordStrengthMeter from "../Register/PasswordStrengthMeter";
import "../Register/Register.css";

import SignupContainer from "../Signup-Login/SignupContainer";
import GoogleDivider from "../Signup-Login/GoogleDivider";
import LinkToCreateAccount from "../Signup-Login/LinkToCreateAccount";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import TermsAndConditionsCollege from "../Register/TermsAndConditionsCollege";
import SignupToggle from "../Signup-Login/SignupToggle";
import { API } from "../../API";

const RegisterCollege = (props) => {
  const [viewedTermsAndConditions, setViewTermsAndConditions] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [institution, setInstitution] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [checkPassword, setCheckPassword] = useState([]);
  const [checkEmail, setCheckEmail] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [error, setError] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isGoogleButton, setIsGoogleButton] = useState(true);
  const URL = PORT;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (passwordStrength >= 1 && checkPassword.length == 0) {
      if (password === confirmPassword) {
        setError(false);
        setIsSendingEmail(true);
        const isChildcareCentre = localStorage.getItem("isChildcareCentre") === "yes" || false
        localStorage.removeItem("isChildcareCentre")

        await API.registerCustomer({
          email,
          password,
          is_childcare_centre: isChildcareCentre
          // institution,
        })
          .then((res) => {
            // console.log(res.data);
            switch (res.data.reason) {
              case "customer-existent-email":
                console.log(res.data);
                notify.show(
                  <React.Fragment>
                    {res.data.msg}
                    <a href="/LoginAsInstitution">
                      <b> login screen</b>.
                    </a>
                  </React.Fragment>
                );
                break;
              case "personnel-existent-email":
                console.log(res.data);
                notify.show(
                  <React.Fragment>
                    {res.data.msg}
                    <a href="/LoginAsInstitution">
                      <b>login screen</b>.
                    </a>
                  </React.Fragment>
                );
                break;
              case "user-existent-email":
                console.log(res.data);
                notify.show(
                  <React.Fragment>
                    {res.data.msg}
                    <a href="/Login">
                      <b>login screen</b>.
                    </a>
                  </React.Fragment>
                );
                break;
                case "customer-existent-email":
                  console.log(res.data);
                  notify.show(
                    <React.Fragment>
                      {res.data.msg}
                      <a href="/Login">
                        <b>login screen</b>.
                      </a>
                    </React.Fragment>
                  );
                  break;
              default:
                console.log(res.data);
                notify.show(res.data.msg);
            }

            // if (res.data.reason === 'instituition-existent-email') {
            //   console.log(res.data);
            //   notify.show(
            //     <>
            //       {res.data.msg}
            //       <a href='/LoginAsInstitution'>
            //         <b>sign in screen</b>.
            //       </a>
            //     </>
            //   );
            // } else {
            //   notify.show(res.data.msg);
            // }

            setIsSendingEmail(false);
            res.data.email ? setIsRegistered(false) : setIsRegistered(true);
          })
          .catch((err) => {
            console.log("Register.js: ", err.response);
            notify.show(
              "There was a problem creating your account. Please try again later."
            );
          });
      } else {
        setError(true);
        notify.show("Passwords do not match.");
      }
    } else {
      notify.show("Check the required password condition.");
    }
  };

  const togglePassword = () => {
    //Toggles between showing and hiding password
    setShowPassword(!showPassword);
  };

  const hideGoogleRegisterForm = () => {
    document.getElementById("google-register-form").style.display = "none";
  };
  // Not required as at 8/9/21 - Ming
  // const showGoogleRegisterForm = () => {
  //   document.getElementById("google-register-form").style.display = "block"
  //   hideLinkedinRegisterForm()
  //   hideEmailAndPassRegisterForm()
  // }
  const hideEmailAndPassRegisterForm = () => {
    document.getElementById("emailandpass-register-form").style.display =
      "none";
  };

  const toggleConfirmPassword = () => {
    //Toggles between showing and hiding password
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handlePasswordStrength = () => {
    setPasswordStrength(document.querySelector("progress").value);
  };

  const responseFromGoogle = async (response) => {
    // console.log(response)
    if (response.profileObj) {

      await API.loginGoogleCustomer({
        token: response.tokenId
      })
        .then((res) => {
          window.localStorage.setItem("token", res.data.user["token"]);
          const data = res.data.user;
          const path = {
            pathname: "/",
            state: data,
          };
          props.history.push(path);
        })
        .catch(async (err) => {
          if (
            /^([a-zA-Z0-9_\-\.]+)@[a-zA-Z0-9_\-\.](edu.au)$/.test(
              response.profileObj.email
            )
          ) {
            const isChildcareCentre = localStorage.getItem("isChildcareCentre") === "yes" || false
            localStorage.removeItem("isChildcareCentre")
            await API.registerCustomerGoogle({
              email: response.profileObj.email ,
              is_childcare_centre: isChildcareCentre
            })
              .then((res) => {
                if(res.data?.reason) {
                  switch (res.data?.reason) {
                    case "customer-existent-email":
                      notify.show(
                        <React.Fragment>
                          {res.data?.msg}
                          <a href="/LoginAsInstitution">
                            <b>login screen</b>.
                          </a>
                        </React.Fragment>
                      );
                      break;
                    case "user-existent-email":
                        console.log('user-existent-email res.data', res.data);
                        notify.show(
                          <React.Fragment>
                            {res.data.msg}
                            <a href="/Login">
                              <b>login screen</b>.
                            </a>
                          </React.Fragment>
                        );
                        break;
                    case "personnel-existent-email":
                      console.log('personnel-existent-email res.data', res.data);
                      notify.show(
                        <React.Fragment>
                          {res.data.msg}
                          <a href="/LoginAsInstitution">
                            <b>login screen</b>.
                          </a>
                        </React.Fragment>
                      );
                      break;
                    default:
                      setIsRegistered(true);
                      break;
                  }
                }
                console.log(res);
                notify.show(res.data?.msg)
              })
              .catch((err) => {
                console.log(err);
              });

          } else {
            notify.show('Please register with a ".edu" email.');
          }
        });
    } else {
      console.log("Fail");
      console.log(response);
    }
  };

  const handlePassword = (e) => {
    let password = e.target.value;
    let passwordarray = [];
    if (!password.match(".{8,}")) passwordarray.push("8 characters");
    if (!password.match("(?=.*?[0-9])")) passwordarray.push("1 digit");
    setCheckPassword(passwordarray);
  };
  // Not required as at 8/9/21 - Ming
  // const handleEmail = (e) => {
  //   let email = e.target.value
  //   let emailarray = []
  //   if (!email.match("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.+-]+\.edu(?:\.\w{2,3})?$"))
  //     emailarray.push("This email is invalid. ")
  //   setCheckEmail(emailarray)
  // }

  // const checkTerm = () => {
  //   if (!document.getElementById("terms-co-check-linkedin").checked) {
  //     notify.show("Please accept terms and condtions.")
  //   } else {
  //     window.location = `${PORT}/auth/linkedin/login`
  //   }
  // }

  const setGoogleButton = () => {
    if (!document.getElementById("terms-co-check-google").checked) {
      notify.show("Please accept the Terms and Conditions.");
      setIsGoogleButton(false);
    }
  };

  const handleAcceptBox = () => {
    if (!viewedTermsAndConditions) {
      notify.show(
        "Please view the Terms and Conditions before accepting them."
      );
      document.getElementById("terms-co-check").checked = false;
      return;
    }
    if (!document.getElementById("terms-co-check-google").checked) {
      setIsGoogleButton(true);
    } else {
      setIsGoogleButton(false);
    }
  };

  const showTermsAndCo = () => {
    setViewTermsAndConditions(true);
    setShowPopup(true);
  };

  const hideTermsAndCo = () => {
    setShowPopup(false);
  };

  const acceptButtonCheck = (flag) => {
    if (flag) {
      document.getElementById("terms-co-check").checked = true;
      setIsGoogleButton(false);
    } else {
      document.getElementById("terms-co-check").checked = false;
      setIsGoogleButton(true);
    }
  };

  return (
    <>
      {/* If isRegistered is true => redirect to home; else stay at login */}
      {isRegistered ? (
        <Redirect to={{ pathname: "/beforeEmailConfirm", emailId: email }} />
      ) : null}
      <SignupContainer
        heading="Sign up as"
        onSubmit={handleSubmit}
        toggle={
          <div className="row justify-content-center login-toggle-container">
            <SignupToggle />
          </div>
        }
        google={
          <GoogleDivider
            onSuccess={responseFromGoogle}
            onFailure={responseFromGoogle}
            buttonText="Sign up with Google"
          />
        }
      >
        {/* Not required as at 8/9/21 - Ming */}
        {/* <FormField
          label="Institute Name"
          type="text"
          icon="mdi mdi-home-modern"
          placeholder="Please Enter The Institute Name"
          value={institution}
          onChange={(e) => setInstitution(e.target.value)}
          autoFocus
          required
        /> */}

        <div className='center-form'>
          <FormField
            label="Email"
            type="email"
            icon="email"
            placeholder="name@email.com"
            value={email}
            // pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.+-]+\.edu(?:\.\w{2,3})?$"
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
            // title="You must enter a valid '.edu' email address."
            autoFocus
            required
            header={checkEmail[0]}
          />
          <FormField
            label="Password"
            icon="lock"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => (setPassword(e.target.value), handlePassword(e))}
            required
            header={
              checkPassword.length > 0
                ? checkPassword.length > 1
                  ? " must contain " +
                    checkPassword[0] +
                    " including " +
                    checkPassword[1]
                  : " must contain " + checkPassword[0]
                : null
            }
          >
            <PasswordToggle onClick={togglePassword} />
          </FormField>
          <PasswordStrengthMeter password={password} />
          <FormField
            label="Confirm Password"
            icon="lock"
            type={showConfirmPassword ? "text" : "password"}
            className={
              confirmPassword !== "" && confirmPassword !== password
                ? "error-form-control"
                : ""
            }
            placeholder="Repeat Your Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          >
            <PasswordToggle onClick={toggleConfirmPassword} />
          </FormField>
        </div>

        {/* large screen */}
        <div className="d-flex sign-up-footer justify-content-center">
          <ConfirmButton
            className="signup-button"
            disabled={isSendingEmail}
            onClick={handlePasswordStrength}
            type="submit"
          >
            Submit
          </ConfirmButton>
        </div>
        <LinkToCreateAccount onRegister />

        {/* register with google form */}
        <div id="google-register-form" className="white-bcg">
          <div className="p-5 gray-shadow-box mt-4" id="form-register">
            <p className="text-gradient">
              Please, accept Terms and Conditions to register with us
            </p>

            <div className=" form-check text-center terms-and-conditions-check h-45 pt-2">
              <div id="r8-balloon-radio-group-wrapper-register">
                <ul className="register-check-agree">
                  <li>
                    <input
                      className="radio r8-radio-float"
                      id="terms-co-check-google"
                      type="checkbox"
                      name="balloon-radio-group"
                      onClick={handleAcceptBox}
                    />
                  </li>
                </ul>
              </div>
              <label
                htmlFor="terms-co-check"
                onClick={handleAcceptBox}
                id="terms-co-check-accept"
              >
                I Accept
              </label>
              <label id="terms-and-conditions-link" onClick={showTermsAndCo}>
                &nbsp;Terms and Conditions
              </label>
            </div>
            {/* <h5 className="text-center mb-4 text-gradient">Register with Google</h5> */}
            <hr className="qualification-line mb-3"></hr>

            {/* large screen */}
            <div className="row qualification-footer small-screen-disappear">
              <div className="col-md-5 mb-1">
                <CancelButton onClick={hideGoogleRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-7">
                <GoogleLogin
                  className="pr-0 btn btn-primary btn-block primary-button-no-margin-hover btn-c google-button text-white p-2 opacity-100"
                  onSuccess={responseFromGoogle}
                  onFailure={responseFromGoogle}
                  disabled={isGoogleButton}
                  cookiePolicy={"single_host_origin"}
                >
                  <div
                    className="small-screen-google-button"
                    onClick={setGoogleButton}
                    style={{ width: "100%" }}
                  >
                    Register with Google{" "}
                  </div>
                </GoogleLogin>
              </div>
            </div>
            {/* small screen */}
            <div className="row qualification-footer  small-screen-appear d-none">
              <div className="col-md-7 mb-1">
                <GoogleLogin
                  className="pr-0 btn btn-primary btn-block primary-button-no-margin-hover btn-c google-button text-white p-2 opacity-100"
                  onSuccess={responseFromGoogle}
                  onFailure={responseFromGoogle}
                  disabled={isGoogleButton}
                  cookiePolicy={"single_host_origin"}
                >
                  <div
                    className="small-screen-google-button"
                    onClick={setGoogleButton}
                    style={{ width: "100%" }}
                  >
                    Register with Google{" "}
                  </div>
                </GoogleLogin>
              </div>
              <div className="col-md-5">
                <CancelButton onClick={hideGoogleRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
            </div>
          </div>
        </div>
      </SignupContainer>

      <TermsAndConditionsCollege
        show={showPopup}
        onClose={(event) => {
          // acceptButtonCheck(!document.getElementById("terms-co-check").checked);
          hideTermsAndCo();
        }}
        onCancel={(event) => {
          acceptButtonCheck(false);
          hideTermsAndCo();
        }}
        onConfirm={(event) => {
          acceptButtonCheck(true);
          hideTermsAndCo();
        }}
      />
    </>
  );
};

export default RegisterCollege;
